import { FinanceRate } from '@kanda-libs/ks-frontend-services';

export const getAprs = (
  rates: FinanceRate[],
): number[] => // Map to apr and make the array unique
  rates
    .map((rate) => rate.apr || 0)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort((a, b) => a - b);

export const filterOutInvalidRates = (
  rates: FinanceRate[],
  aprsToExclude: string[],
  bnpl = false,
): FinanceRate[] =>
  rates
    // Filter for enabled rates
    .filter((rate) => rate.enabled)
    // Filter out APRs that have been marked as excluded in the excludeAprs query param
    .filter((rate) => {
      const apr = String(rate.apr || 0);
      const bnplRate = rate.apr_type === 'BUYNOW_PAYLATER';
      if (bnplRate && aprsToExclude.includes('bnpl')) return false;
      return !aprsToExclude.includes(apr)
    })
    // Filter out second line rates
    .filter((rate) => !rate.finance_types?.includes('secondary'))
    // Filter out BNPL/only inlcude BNPL
    .filter((rate) =>
      bnpl
        ? rate.apr_type === 'BUYNOW_PAYLATER'
        : rate.apr_type !== 'BUYNOW_PAYLATER',
    );

export const getLowestDuration = (rates: FinanceRate[]): number =>
  rates.reduce(
    (acc, rate) => ((rate.duration || 0) < acc ? rate.duration || 0 : acc),
    Infinity,
  );
